import React from "react";
import PropTypes from "prop-types";

const ARHiddenColumnsFilter = React.memo(({hiddenColumnsInfo, toggleHiddenColumns, gridHiddenColumns}) => {

    return (
        <div className={"d-flex flex-wrap"}>
            {hiddenColumnsInfo.map(item => {
                const id = item.ComboSetId;
                const isChecked = gridHiddenColumns.indexOf(id) < 0;
                return (
                    <div key={id} className={"mr-2 nowrap"}>
                        <input type={"checkbox"} className={"c-pointer"} id={id}
                               onChange={() => toggleHiddenColumns(id)} checked={isChecked}/>&nbsp;
                        <label htmlFor={id} className={"c-pointer"}>{item.ComboSetName}</label>&nbsp;&nbsp;
                    </div>
                )
            })}
        </div>
    );
}, (p,n) => {
    return p.gridHiddenColumns === n.gridHiddenColumns &&
      p.toggleHiddenColumns === n.toggleHiddenColumns &&
      p.gridHiddenColumns === n.gridHiddenColumns;
})

ARHiddenColumnsFilter.propTypes = {
    hiddenColumnsInfo: PropTypes.array.isRequired,
    gridHiddenColumns: PropTypes.array.isRequired,
    toggleHiddenColumns: PropTypes.func.isRequired,
};

export { ARHiddenColumnsFilter };